export default __webpack_public_path__ + "static/media/excel.3aacda50.png";